<template>
    <div
        class="xems-spinner"
        :class="{
            'xems-spinner-small': size === 'small',
            'xems-spinner-medium': size === 'medium',
            'xems-spinner-large': size === 'large',
        }"
    >
        <div class="xems-spinner-loader"></div>
    </div>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            default: "medium",
            validator: (value) => ["small", "medium", "large"].includes(value),
        },
        text: {
            type: String,
            default: "Loading...",
        },
    },
};
</script>

<style scoped>
.xems-spinner {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 56px;
    height: 20px;
    overflow: visible;
}

.xems-spinner-loader {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #007bff;
    box-shadow: 16px 0 #007bff, -16px 0 #007bff;
    position: relative;
    animation: xems-spinner-flash-medium 0.5s ease-out infinite alternate;
}

.xems-spinner-small {
    width: 36px;
    height: 16px;
}

.xems-spinner-small .xems-spinner-loader {
    width: 12px;
    height: 12px;
    box-shadow: 12px 0 #007bff, -12px 0 #007bff;
    animation: xems-spinner-flash-small 0.4s ease-out infinite alternate;
}

.xems-spinner-medium .xems-spinner-loader {
    width: 16px;
    height: 16px;
    box-shadow: 20px 0 #007bff, -20px 0 #007bff;
    animation: xems-spinner-flash-medium 0.5s ease-out infinite alternate;
}

.xems-spinner-large {
    width: 84px;
    height: 24px;
}

.xems-spinner-large .xems-spinner-loader {
    width: 20px;
    height: 20px;
    box-shadow: 32px 0 #007bff, -32px 0 #007bff;
    animation: xems-spinner-flash-large 0.6s ease-out infinite alternate;
}

/* Small 애니메이션 */
@keyframes xems-spinner-flash-small {
    0% {
        background-color: #007bff22;
        box-shadow: 15px 0 #007bff22, -15px 0 #007bff;
    }
    50% {
        background-color: #007bff;
        box-shadow: 15px 0 #007bff22, -15px 0 #007bff22;
    }
    100% {
        background-color: #007bff22;
        box-shadow: 15px 0 #007bff, -15px 0 #007bff22;
    }
}

/* Medium 애니메이션 */
@keyframes xems-spinner-flash-medium {
    0% {
        background-color: #007bff22;
        box-shadow: 20px 0 #007bff22, -20px 0 #007bff;
    }
    50% {
        background-color: #007bff;
        box-shadow: 20px 0 #007bff22, -20px 0 #007bff22;
    }
    100% {
        background-color: #007bff22;
        box-shadow: 20px 0 #007bff, -20px 0 #007bff22;
    }
}

/* Large 애니메이션 */
@keyframes xems-spinner-flash-large {
    0% {
        background-color: #007bff22;
        box-shadow: 32px 0 #007bff22, -32px 0 #007bff;
    }
    50% {
        background-color: #007bff;
        box-shadow: 32px 0 #007bff22, -32px 0 #007bff22;
    }
    100% {
        background-color: #007bff22;
        box-shadow: 32px 0 #007bff, -32px 0 #007bff22;
    }
}
</style>
